import React from 'react';
import { Box, Chip } from '@mui/material';
import { CheckCircle, Pending } from '@mui/icons-material';

// Define props interface
interface UCCFormStatusSummaryProps {
    status: string;
    count: number;
}

const UCCFormStatusSummary: React.FC<UCCFormStatusSummaryProps> = ({ status, count }) => {
  // Check if all forms are completed

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
      {status === 'Completed' ? (
        <Chip
          icon={<CheckCircle />}
          label="All Forms Completed"
          color="success"
          size="small"
          sx={{ fontWeight: 500 }}
        />
      ) : (
        <Chip
          icon={<Pending />}
          label={`${count} Form${count !== 1 ? 's' : ''} Pending`}
          color="warning"
          size="small"
          sx={{ fontWeight: 500 }}
        />
      )}
    </Box>
  );
};

export default UCCFormStatusSummary;